var cov_ezqsz1upr = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Table/select.tsx",
      hash = "ad953876f386c824ee75d48bfae4f1170ddf6b89",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Table/select.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 20
        },
        end: {
          line: 10,
          column: 40
        }
      },
      "1": {
        start: {
          line: 11,
          column: 16
        },
        end: {
          line: 11,
          column: 36
        }
      },
      "2": {
        start: {
          line: 12,
          column: 20
        },
        end: {
          line: 12,
          column: 46
        }
      },
      "3": {
        start: {
          line: 16,
          column: 15
        },
        end: {
          line: 16,
          column: 24
        }
      },
      "4": {
        start: {
          line: 17,
          column: 2
        },
        end: {
          line: 17,
          column: 60
        }
      },
      "5": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 22,
          column: 44
        }
      },
      "6": {
        start: {
          line: 22,
          column: 35
        },
        end: {
          line: 22,
          column: 44
        }
      },
      "7": {
        start: {
          line: 23,
          column: 37
        },
        end: {
          line: 23,
          column: 39
        }
      },
      "8": {
        start: {
          line: 24,
          column: 26
        },
        end: {
          line: 24,
          column: 28
        }
      },
      "9": {
        start: {
          line: 25,
          column: 2
        },
        end: {
          line: 37,
          column: 4
        }
      },
      "10": {
        start: {
          line: 26,
          column: 15
        },
        end: {
          line: 26,
          column: 70
        }
      },
      "11": {
        start: {
          line: 27,
          column: 16
        },
        end: {
          line: 27,
          column: 31
        }
      },
      "12": {
        start: {
          line: 28,
          column: 4
        },
        end: {
          line: 31,
          column: 5
        }
      },
      "13": {
        start: {
          line: 29,
          column: 6
        },
        end: {
          line: 29,
          column: 18
        }
      },
      "14": {
        start: {
          line: 30,
          column: 6
        },
        end: {
          line: 30,
          column: 28
        }
      },
      "15": {
        start: {
          line: 32,
          column: 4
        },
        end: {
          line: 36,
          column: 5
        }
      },
      "16": {
        start: {
          line: 33,
          column: 6
        },
        end: {
          line: 33,
          column: 37
        }
      },
      "17": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 35
        }
      },
      "18": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 12
        }
      },
      "19": {
        start: {
          line: 45,
          column: 2
        },
        end: {
          line: 45,
          column: 42
        }
      },
      "20": {
        start: {
          line: 45,
          column: 33
        },
        end: {
          line: 45,
          column: 42
        }
      },
      "21": {
        start: {
          line: 46,
          column: 12
        },
        end: {
          line: 46,
          column: 14
        }
      },
      "22": {
        start: {
          line: 47,
          column: 2
        },
        end: {
          line: 53,
          column: 4
        }
      },
      "23": {
        start: {
          line: 48,
          column: 4
        },
        end: {
          line: 52,
          column: 5
        }
      },
      "24": {
        start: {
          line: 49,
          column: 6
        },
        end: {
          line: 49,
          column: 25
        }
      },
      "25": {
        start: {
          line: 51,
          column: 6
        },
        end: {
          line: 51,
          column: 42
        }
      },
      "26": {
        start: {
          line: 54,
          column: 2
        },
        end: {
          line: 54,
          column: 12
        }
      },
      "27": {
        start: {
          line: 60,
          column: 2
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "28": {
        start: {
          line: 60,
          column: 13
        },
        end: {
          line: 60,
          column: 19
        }
      },
      "29": {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 61,
          column: 53
        }
      },
      "30": {
        start: {
          line: 62,
          column: 2
        },
        end: {
          line: 62,
          column: 47
        }
      },
      "31": {
        start: {
          line: 63,
          column: 2
        },
        end: {
          line: 63,
          column: 23
        }
      },
      "32": {
        start: {
          line: 66,
          column: 2
        },
        end: {
          line: 66,
          column: 35
        }
      },
      "33": {
        start: {
          line: 67,
          column: 2
        },
        end: {
          line: 67,
          column: 32
        }
      },
      "34": {
        start: {
          line: 68,
          column: 2
        },
        end: {
          line: 68,
          column: 33
        }
      },
      "35": {
        start: {
          line: 70,
          column: 2
        },
        end: {
          line: 70,
          column: 32
        }
      },
      "36": {
        start: {
          line: 71,
          column: 2
        },
        end: {
          line: 71,
          column: 19
        }
      },
      "37": {
        start: {
          line: 72,
          column: 2
        },
        end: {
          line: 74,
          column: 3
        }
      },
      "38": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 73,
          column: 32
        }
      },
      "39": {
        start: {
          line: 75,
          column: 2
        },
        end: {
          line: 75,
          column: 80
        }
      },
      "40": {
        start: {
          line: 75,
          column: 39
        },
        end: {
          line: 75,
          column: 80
        }
      },
      "41": {
        start: {
          line: 80,
          column: 2
        },
        end: {
          line: 83,
          column: 3
        }
      },
      "42": {
        start: {
          line: 81,
          column: 4
        },
        end: {
          line: 81,
          column: 37
        }
      },
      "43": {
        start: {
          line: 82,
          column: 4
        },
        end: {
          line: 82,
          column: 10
        }
      },
      "44": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 84,
          column: 19
        }
      },
      "45": {
        start: {
          line: 84,
          column: 13
        },
        end: {
          line: 84,
          column: 19
        }
      },
      "46": {
        start: {
          line: 85,
          column: 16
        },
        end: {
          line: 85,
          column: 60
        }
      },
      "47": {
        start: {
          line: 86,
          column: 2
        },
        end: {
          line: 86,
          column: 31
        }
      },
      "48": {
        start: {
          line: 86,
          column: 25
        },
        end: {
          line: 86,
          column: 31
        }
      },
      "49": {
        start: {
          line: 87,
          column: 2
        },
        end: {
          line: 89,
          column: 4
        }
      },
      "50": {
        start: {
          line: 88,
          column: 4
        },
        end: {
          line: 88,
          column: 27
        }
      },
      "51": {
        start: {
          line: 90,
          column: 15
        },
        end: {
          line: 90,
          column: 56
        }
      },
      "52": {
        start: {
          line: 91,
          column: 2
        },
        end: {
          line: 91,
          column: 52
        }
      },
      "53": {
        start: {
          line: 91,
          column: 12
        },
        end: {
          line: 91,
          column: 52
        }
      },
      "54": {
        start: {
          line: 96,
          column: 2
        },
        end: {
          line: 96,
          column: 18
        }
      },
      "55": {
        start: {
          line: 96,
          column: 12
        },
        end: {
          line: 96,
          column: 18
        }
      },
      "56": {
        start: {
          line: 97,
          column: 2
        },
        end: {
          line: 97,
          column: 30
        }
      },
      "57": {
        start: {
          line: 101,
          column: 2
        },
        end: {
          line: 104,
          column: 3
        }
      },
      "58": {
        start: {
          line: 102,
          column: 4
        },
        end: {
          line: 102,
          column: 44
        }
      },
      "59": {
        start: {
          line: 103,
          column: 4
        },
        end: {
          line: 103,
          column: 10
        }
      },
      "60": {
        start: {
          line: 105,
          column: 2
        },
        end: {
          line: 105,
          column: 45
        }
      },
      "61": {
        start: {
          line: 110,
          column: 17
        },
        end: {
          line: 110,
          column: 44
        }
      },
      "62": {
        start: {
          line: 111,
          column: 2
        },
        end: {
          line: 115,
          column: 10
        }
      },
      "63": {
        start: {
          line: 115,
          column: 4
        },
        end: {
          line: 115,
          column: 10
        }
      },
      "64": {
        start: {
          line: 116,
          column: 2
        },
        end: {
          line: 116,
          column: 21
        }
      },
      "65": {
        start: {
          line: 117,
          column: 2
        },
        end: {
          line: 117,
          column: 21
        }
      },
      "66": {
        start: {
          line: 123,
          column: 2
        },
        end: {
          line: 123,
          column: 78
        }
      },
      "67": {
        start: {
          line: 123,
          column: 72
        },
        end: {
          line: 123,
          column: 78
        }
      },
      "68": {
        start: {
          line: 124,
          column: 14
        },
        end: {
          line: 124,
          column: 73
        }
      },
      "69": {
        start: {
          line: 125,
          column: 2
        },
        end: {
          line: 127,
          column: 4
        }
      },
      "70": {
        start: {
          line: 126,
          column: 4
        },
        end: {
          line: 126,
          column: 26
        }
      },
      "71": {
        start: {
          line: 132,
          column: 13
        },
        end: {
          line: 132,
          column: 66
        }
      },
      "72": {
        start: {
          line: 134,
          column: 2
        },
        end: {
          line: 134,
          column: 17
        }
      },
      "73": {
        start: {
          line: 134,
          column: 11
        },
        end: {
          line: 134,
          column: 17
        }
      },
      "74": {
        start: {
          line: 136,
          column: 14
        },
        end: {
          line: 136,
          column: 39
        }
      },
      "75": {
        start: {
          line: 137,
          column: 17
        },
        end: {
          line: 137,
          column: 64
        }
      },
      "76": {
        start: {
          line: 139,
          column: 14
        },
        end: {
          line: 139,
          column: 15
        }
      },
      "77": {
        start: {
          line: 141,
          column: 2
        },
        end: {
          line: 150,
          column: 3
        }
      },
      "78": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "79": {
        start: {
          line: 143,
          column: 18
        },
        end: {
          line: 143,
          column: 51
        }
      },
      "80": {
        start: {
          line: 144,
          column: 6
        },
        end: {
          line: 144,
          column: 47
        }
      },
      "81": {
        start: {
          line: 146,
          column: 4
        },
        end: {
          line: 148,
          column: 5
        }
      },
      "82": {
        start: {
          line: 147,
          column: 6
        },
        end: {
          line: 147,
          column: 11
        }
      },
      "83": {
        start: {
          line: 149,
          column: 4
        },
        end: {
          line: 149,
          column: 14
        }
      },
      "84": {
        start: {
          line: 154,
          column: 2
        },
        end: {
          line: 154,
          column: 64
        }
      },
      "85": {
        start: {
          line: 154,
          column: 58
        },
        end: {
          line: 154,
          column: 64
        }
      },
      "86": {
        start: {
          line: 156,
          column: 16
        },
        end: {
          line: 156,
          column: 92
        }
      },
      "87": {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 157,
          column: 24
        }
      },
      "88": {
        start: {
          line: 161,
          column: 0
        },
        end: {
          line: 163,
          column: 2
        }
      },
      "89": {
        start: {
          line: 162,
          column: 2
        },
        end: {
          line: 162,
          column: 54
        }
      },
      "90": {
        start: {
          line: 172,
          column: 2
        },
        end: {
          line: 288,
          column: 3
        }
      },
      "91": {
        start: {
          line: 186,
          column: 6
        },
        end: {
          line: 186,
          column: 18
        }
      },
      "92": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 188,
          column: 21
        }
      },
      "93": {
        start: {
          line: 190,
          column: 6
        },
        end: {
          line: 190,
          column: 34
        }
      },
      "94": {
        start: {
          line: 192,
          column: 6
        },
        end: {
          line: 192,
          column: 22
        }
      },
      "95": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 194,
          column: 23
        }
      },
      "96": {
        start: {
          line: 195,
          column: 6
        },
        end: {
          line: 195,
          column: 21
        }
      },
      "97": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 25
        }
      },
      "98": {
        start: {
          line: 198,
          column: 6
        },
        end: {
          line: 198,
          column: 60
        }
      },
      "99": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 199,
          column: 56
        }
      },
      "100": {
        start: {
          line: 200,
          column: 6
        },
        end: {
          line: 200,
          column: 60
        }
      },
      "101": {
        start: {
          line: 202,
          column: 6
        },
        end: {
          line: 206,
          column: 7
        }
      },
      "102": {
        start: {
          line: 203,
          column: 8
        },
        end: {
          line: 203,
          column: 54
        }
      },
      "103": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 50
        }
      },
      "104": {
        start: {
          line: 205,
          column: 8
        },
        end: {
          line: 205,
          column: 54
        }
      },
      "105": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 212,
          column: 7
        }
      },
      "106": {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 211,
          column: 64
        }
      },
      "107": {
        start: {
          line: 216,
          column: 6
        },
        end: {
          line: 218,
          column: 7
        }
      },
      "108": {
        start: {
          line: 217,
          column: 8
        },
        end: {
          line: 217,
          column: 25
        }
      },
      "109": {
        start: {
          line: 222,
          column: 44
        },
        end: {
          line: 222,
          column: 54
        }
      },
      "110": {
        start: {
          line: 223,
          column: 6
        },
        end: {
          line: 223,
          column: 40
        }
      },
      "111": {
        start: {
          line: 227,
          column: 6
        },
        end: {
          line: 227,
          column: 56
        }
      },
      "112": {
        start: {
          line: 231,
          column: 6
        },
        end: {
          line: 231,
          column: 49
        }
      },
      "113": {
        start: {
          line: 231,
          column: 43
        },
        end: {
          line: 231,
          column: 49
        }
      },
      "114": {
        start: {
          line: 232,
          column: 6
        },
        end: {
          line: 232,
          column: 29
        }
      },
      "115": {
        start: {
          line: 235,
          column: 6
        },
        end: {
          line: 235,
          column: 22
        }
      },
      "116": {
        start: {
          line: 237,
          column: 17
        },
        end: {
          line: 237,
          column: 85
        }
      },
      "117": {
        start: {
          line: 238,
          column: 17
        },
        end: {
          line: 238,
          column: 70
        }
      },
      "118": {
        start: {
          line: 239,
          column: 6
        },
        end: {
          line: 239,
          column: 23
        }
      },
      "119": {
        start: {
          line: 240,
          column: 6
        },
        end: {
          line: 240,
          column: 21
        }
      },
      "120": {
        start: {
          line: 240,
          column: 15
        },
        end: {
          line: 240,
          column: 21
        }
      },
      "121": {
        start: {
          line: 241,
          column: 21
        },
        end: {
          line: 241,
          column: 68
        }
      },
      "122": {
        start: {
          line: 242,
          column: 21
        },
        end: {
          line: 242,
          column: 80
        }
      },
      "123": {
        start: {
          line: 243,
          column: 6
        },
        end: {
          line: 243,
          column: 32
        }
      },
      "124": {
        start: {
          line: 244,
          column: 6
        },
        end: {
          line: 244,
          column: 32
        }
      },
      "125": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 25
        }
      },
      "126": {
        start: {
          line: 249,
          column: 6
        },
        end: {
          line: 249,
          column: 49
        }
      },
      "127": {
        start: {
          line: 249,
          column: 43
        },
        end: {
          line: 249,
          column: 49
        }
      },
      "128": {
        start: {
          line: 250,
          column: 21
        },
        end: {
          line: 250,
          column: 48
        }
      },
      "129": {
        start: {
          line: 251,
          column: 17
        },
        end: {
          line: 251,
          column: 64
        }
      },
      "130": {
        start: {
          line: 252,
          column: 6
        },
        end: {
          line: 261,
          column: 7
        }
      },
      "131": {
        start: {
          line: 253,
          column: 8
        },
        end: {
          line: 253,
          column: 23
        }
      },
      "132": {
        start: {
          line: 254,
          column: 8
        },
        end: {
          line: 254,
          column: 25
        }
      },
      "133": {
        start: {
          line: 255,
          column: 8
        },
        end: {
          line: 258,
          column: 9
        }
      },
      "134": {
        start: {
          line: 256,
          column: 10
        },
        end: {
          line: 256,
          column: 31
        }
      },
      "135": {
        start: {
          line: 257,
          column: 10
        },
        end: {
          line: 257,
          column: 16
        }
      },
      "136": {
        start: {
          line: 259,
          column: 8
        },
        end: {
          line: 259,
          column: 29
        }
      },
      "137": {
        start: {
          line: 260,
          column: 8
        },
        end: {
          line: 260,
          column: 14
        }
      },
      "138": {
        start: {
          line: 262,
          column: 6
        },
        end: {
          line: 262,
          column: 25
        }
      },
      "139": {
        start: {
          line: 264,
          column: 6
        },
        end: {
          line: 264,
          column: 43
        }
      },
      "140": {
        start: {
          line: 267,
          column: 6
        },
        end: {
          line: 267,
          column: 21
        }
      },
      "141": {
        start: {
          line: 268,
          column: 6
        },
        end: {
          line: 268,
          column: 23
        }
      },
      "142": {
        start: {
          line: 272,
          column: 6
        },
        end: {
          line: 272,
          column: 28
        }
      },
      "143": {
        start: {
          line: 272,
          column: 22
        },
        end: {
          line: 272,
          column: 28
        }
      },
      "144": {
        start: {
          line: 274,
          column: 17
        },
        end: {
          line: 274,
          column: 85
        }
      },
      "145": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 275,
          column: 37
        }
      },
      "146": {
        start: {
          line: 275,
          column: 31
        },
        end: {
          line: 275,
          column: 37
        }
      },
      "147": {
        start: {
          line: 276,
          column: 6
        },
        end: {
          line: 276,
          column: 23
        }
      },
      "148": {
        start: {
          line: 279,
          column: 6
        },
        end: {
          line: 279,
          column: 25
        }
      },
      "149": {
        start: {
          line: 281,
          column: 6
        },
        end: {
          line: 281,
          column: 43
        }
      },
      "150": {
        start: {
          line: 285,
          column: 59
        },
        end: {
          line: 285,
          column: 69
        }
      },
      "151": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 286,
          column: 68
        }
      }
    },
    fnMap: {
      "0": {
        name: "isEventCombination",
        decl: {
          start: {
            line: 15,
            column: 9
          },
          end: {
            line: 15,
            column: 27
          }
        },
        loc: {
          start: {
            line: 15,
            column: 82
          },
          end: {
            line: 18,
            column: 1
          }
        },
        line: 15
      },
      "1": {
        name: "mergeDomsText",
        decl: {
          start: {
            line: 21,
            column: 9
          },
          end: {
            line: 21,
            column: 22
          }
        },
        loc: {
          start: {
            line: 21,
            column: 63
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 21
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 25,
            column: 16
          },
          end: {
            line: 25,
            column: 17
          }
        },
        loc: {
          start: {
            line: 25,
            column: 24
          },
          end: {
            line: 37,
            column: 3
          }
        },
        line: 25
      },
      "3": {
        name: "formatTableText",
        decl: {
          start: {
            line: 44,
            column: 9
          },
          end: {
            line: 44,
            column: 24
          }
        },
        loc: {
          start: {
            line: 44,
            column: 42
          },
          end: {
            line: 55,
            column: 1
          }
        },
        line: 44
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 47,
            column: 15
          },
          end: {
            line: 47,
            column: 16
          }
        },
        loc: {
          start: {
            line: 47,
            column: 24
          },
          end: {
            line: 53,
            column: 3
          }
        },
        line: 47
      },
      "5": {
        name: "execCopyCommand",
        decl: {
          start: {
            line: 58,
            column: 9
          },
          end: {
            line: 58,
            column: 24
          }
        },
        loc: {
          start: {
            line: 58,
            column: 39
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 58
      },
      "6": {
        name: "removeSelectClass",
        decl: {
          start: {
            line: 79,
            column: 9
          },
          end: {
            line: 79,
            column: 26
          }
        },
        loc: {
          start: {
            line: 79,
            column: 70
          },
          end: {
            line: 92,
            column: 1
          }
        },
        line: 79
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 87,
            column: 16
          },
          end: {
            line: 87,
            column: 17
          }
        },
        loc: {
          start: {
            line: 87,
            column: 48
          },
          end: {
            line: 89,
            column: 3
          }
        },
        line: 87
      },
      "8": {
        name: "addSelectionClass",
        decl: {
          start: {
            line: 95,
            column: 9
          },
          end: {
            line: 95,
            column: 26
          }
        },
        loc: {
          start: {
            line: 95,
            column: 80
          },
          end: {
            line: 98,
            column: 1
          }
        },
        line: 95
      },
      "9": {
        name: "toggleNoSelection",
        decl: {
          start: {
            line: 100,
            column: 9
          },
          end: {
            line: 100,
            column: 26
          }
        },
        loc: {
          start: {
            line: 100,
            column: 43
          },
          end: {
            line: 106,
            column: 1
          }
        },
        line: 100
      },
      "10": {
        name: "docClick",
        decl: {
          start: {
            line: 109,
            column: 9
          },
          end: {
            line: 109,
            column: 17
          }
        },
        loc: {
          start: {
            line: 109,
            column: 37
          },
          end: {
            line: 118,
            column: 1
          }
        },
        line: 109
      },
      "11": {
        name: "bulkOperation",
        decl: {
          start: {
            line: 122,
            column: 9
          },
          end: {
            line: 122,
            column: 22
          }
        },
        loc: {
          start: {
            line: 122,
            column: 78
          },
          end: {
            line: 128,
            column: 1
          }
        },
        line: 122
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 125,
            column: 14
          },
          end: {
            line: 125,
            column: 15
          }
        },
        loc: {
          start: {
            line: 125,
            column: 45
          },
          end: {
            line: 127,
            column: 3
          }
        },
        line: 125
      },
      "13": {
        name: "bulkAddSelectionClass",
        decl: {
          start: {
            line: 131,
            column: 9
          },
          end: {
            line: 131,
            column: 30
          }
        },
        loc: {
          start: {
            line: 131,
            column: 75
          },
          end: {
            line: 151,
            column: 1
          }
        },
        line: 131
      },
      "14": {
        name: "handleKeyDown",
        decl: {
          start: {
            line: 153,
            column: 9
          },
          end: {
            line: 153,
            column: 22
          }
        },
        loc: {
          start: {
            line: 153,
            column: 45
          },
          end: {
            line: 158,
            column: 1
          }
        },
        line: 153
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 161,
            column: 6
          },
          end: {
            line: 161,
            column: 7
          }
        },
        loc: {
          start: {
            line: 161,
            column: 12
          },
          end: {
            line: 163,
            column: 1
          }
        },
        line: 161
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 171,
            column: 16
          },
          end: {
            line: 171,
            column: 17
          }
        },
        loc: {
          start: {
            line: 172,
            column: 2
          },
          end: {
            line: 288,
            column: 3
          }
        },
        line: 172
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 185,
            column: 5
          }
        },
        loc: {
          start: {
            line: 185,
            column: 46
          },
          end: {
            line: 207,
            column: 5
          }
        },
        line: 185
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 209,
            column: 4
          },
          end: {
            line: 209,
            column: 5
          }
        },
        loc: {
          start: {
            line: 209,
            column: 24
          },
          end: {
            line: 213,
            column: 5
          }
        },
        line: 209
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 215,
            column: 4
          },
          end: {
            line: 215,
            column: 5
          }
        },
        loc: {
          start: {
            line: 215,
            column: 27
          },
          end: {
            line: 219,
            column: 5
          }
        },
        line: 215
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 221,
            column: 4
          },
          end: {
            line: 221,
            column: 5
          }
        },
        loc: {
          start: {
            line: 221,
            column: 20
          },
          end: {
            line: 224,
            column: 5
          }
        },
        line: 221
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 226,
            column: 4
          },
          end: {
            line: 226,
            column: 5
          }
        },
        loc: {
          start: {
            line: 226,
            column: 61
          },
          end: {
            line: 228,
            column: 5
          }
        },
        line: 226
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 230,
            column: 4
          },
          end: {
            line: 230,
            column: 5
          }
        },
        loc: {
          start: {
            line: 230,
            column: 45
          },
          end: {
            line: 246,
            column: 5
          }
        },
        line: 230
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 248,
            column: 4
          },
          end: {
            line: 248,
            column: 5
          }
        },
        loc: {
          start: {
            line: 248,
            column: 59
          },
          end: {
            line: 269,
            column: 5
          }
        },
        line: 248
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 271,
            column: 4
          },
          end: {
            line: 271,
            column: 5
          }
        },
        loc: {
          start: {
            line: 271,
            column: 45
          },
          end: {
            line: 282,
            column: 5
          }
        },
        line: 271
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 284,
            column: 4
          },
          end: {
            line: 284,
            column: 5
          }
        },
        loc: {
          start: {
            line: 284,
            column: 13
          },
          end: {
            line: 287,
            column: 5
          }
        },
        line: 284
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 17,
            column: 9
          },
          end: {
            line: 17,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 17,
            column: 10
          },
          end: {
            line: 17,
            column: 14
          }
        }, {
          start: {
            line: 17,
            column: 18
          },
          end: {
            line: 17,
            column: 31
          }
        }, {
          start: {
            line: 17,
            column: 37
          },
          end: {
            line: 17,
            column: 42
          }
        }, {
          start: {
            line: 17,
            column: 46
          },
          end: {
            line: 17,
            column: 59
          }
        }],
        line: 17
      },
      "1": {
        loc: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 44
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 44
          }
        }, {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 44
          }
        }],
        line: 22
      },
      "2": {
        loc: {
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 22,
            column: 6
          },
          end: {
            line: 22,
            column: 12
          }
        }, {
          start: {
            line: 22,
            column: 16
          },
          end: {
            line: 22,
            column: 33
          }
        }],
        line: 22
      },
      "3": {
        loc: {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        }, {
          start: {
            line: 28,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        }],
        line: 28
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }, {
          start: {
            line: 32,
            column: 4
          },
          end: {
            line: 36,
            column: 5
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 42
          }
        }, {
          start: {
            line: 45,
            column: 2
          },
          end: {
            line: 45,
            column: 42
          }
        }],
        line: 45
      },
      "6": {
        loc: {
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 45,
            column: 6
          },
          end: {
            line: 45,
            column: 11
          }
        }, {
          start: {
            line: 45,
            column: 15
          },
          end: {
            line: 45,
            column: 31
          }
        }],
        line: 45
      },
      "7": {
        loc: {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }, {
          start: {
            line: 48,
            column: 4
          },
          end: {
            line: 52,
            column: 5
          }
        }],
        line: 48
      },
      "8": {
        loc: {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 19
          }
        }, {
          start: {
            line: 60,
            column: 2
          },
          end: {
            line: 60,
            column: 19
          }
        }],
        line: 60
      },
      "9": {
        loc: {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        }, {
          start: {
            line: 72,
            column: 2
          },
          end: {
            line: 74,
            column: 3
          }
        }],
        line: 72
      },
      "10": {
        loc: {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 80
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 80
          }
        }, {
          start: {
            line: 75,
            column: 2
          },
          end: {
            line: 75,
            column: 80
          }
        }],
        line: 75
      },
      "11": {
        loc: {
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 75,
            column: 6
          },
          end: {
            line: 75,
            column: 14
          }
        }, {
          start: {
            line: 75,
            column: 18
          },
          end: {
            line: 75,
            column: 37
          }
        }],
        line: 75
      },
      "12": {
        loc: {
          start: {
            line: 79,
            column: 55
          },
          end: {
            line: 79,
            column: 68
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 79,
            column: 63
          },
          end: {
            line: 79,
            column: 68
          }
        }],
        line: 79
      },
      "13": {
        loc: {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        }, {
          start: {
            line: 80,
            column: 2
          },
          end: {
            line: 83,
            column: 3
          }
        }],
        line: 80
      },
      "14": {
        loc: {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 19
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 19
          }
        }, {
          start: {
            line: 84,
            column: 2
          },
          end: {
            line: 84,
            column: 19
          }
        }],
        line: 84
      },
      "15": {
        loc: {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 31
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 31
          }
        }, {
          start: {
            line: 86,
            column: 2
          },
          end: {
            line: 86,
            column: 31
          }
        }],
        line: 86
      },
      "16": {
        loc: {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 52
          }
        }, {
          start: {
            line: 91,
            column: 2
          },
          end: {
            line: 91,
            column: 52
          }
        }],
        line: 91
      },
      "17": {
        loc: {
          start: {
            line: 95,
            column: 55
          },
          end: {
            line: 95,
            column: 78
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 95,
            column: 67
          },
          end: {
            line: 95,
            column: 78
          }
        }],
        line: 95
      },
      "18": {
        loc: {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 18
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 18
          }
        }, {
          start: {
            line: 96,
            column: 2
          },
          end: {
            line: 96,
            column: 18
          }
        }],
        line: 96
      },
      "19": {
        loc: {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        }, {
          start: {
            line: 101,
            column: 2
          },
          end: {
            line: 104,
            column: 3
          }
        }],
        line: 101
      },
      "20": {
        loc: {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 115,
            column: 10
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 115,
            column: 10
          }
        }, {
          start: {
            line: 111,
            column: 2
          },
          end: {
            line: 115,
            column: 10
          }
        }],
        line: 111
      },
      "21": {
        loc: {
          start: {
            line: 112,
            column: 4
          },
          end: {
            line: 113,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 112,
            column: 5
          },
          end: {
            line: 112,
            column: 55
          }
        }, {
          start: {
            line: 112,
            column: 59
          },
          end: {
            line: 112,
            column: 102
          }
        }, {
          start: {
            line: 113,
            column: 4
          },
          end: {
            line: 113,
            column: 29
          }
        }],
        line: 112
      },
      "22": {
        loc: {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 78
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 78
          }
        }, {
          start: {
            line: 123,
            column: 2
          },
          end: {
            line: 123,
            column: 78
          }
        }],
        line: 123
      },
      "23": {
        loc: {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 11
          }
        }, {
          start: {
            line: 123,
            column: 15
          },
          end: {
            line: 123,
            column: 42
          }
        }, {
          start: {
            line: 123,
            column: 46
          },
          end: {
            line: 123,
            column: 57
          }
        }, {
          start: {
            line: 123,
            column: 61
          },
          end: {
            line: 123,
            column: 70
          }
        }],
        line: 123
      },
      "24": {
        loc: {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 17
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 17
          }
        }, {
          start: {
            line: 134,
            column: 2
          },
          end: {
            line: 134,
            column: 17
          }
        }],
        line: 134
      },
      "25": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }, {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 145,
            column: 5
          }
        }],
        line: 142
      },
      "26": {
        loc: {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }, {
          start: {
            line: 146,
            column: 4
          },
          end: {
            line: 148,
            column: 5
          }
        }],
        line: 146
      },
      "27": {
        loc: {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 64
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 64
          }
        }, {
          start: {
            line: 154,
            column: 2
          },
          end: {
            line: 154,
            column: 64
          }
        }],
        line: 154
      },
      "28": {
        loc: {
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 154,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 6
          },
          end: {
            line: 154,
            column: 32
          }
        }, {
          start: {
            line: 154,
            column: 36
          },
          end: {
            line: 154,
            column: 56
          }
        }],
        line: 154
      },
      "29": {
        loc: {
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        }, {
          start: {
            line: 202,
            column: 6
          },
          end: {
            line: 206,
            column: 7
          }
        }],
        line: 202
      },
      "30": {
        loc: {
          start: {
            line: 202,
            column: 10
          },
          end: {
            line: 202,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 202,
            column: 10
          },
          end: {
            line: 202,
            column: 25
          }
        }, {
          start: {
            line: 202,
            column: 29
          },
          end: {
            line: 202,
            column: 43
          }
        }],
        line: 202
      },
      "31": {
        loc: {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        }, {
          start: {
            line: 210,
            column: 6
          },
          end: {
            line: 212,
            column: 7
          }
        }],
        line: 210
      },
      "32": {
        loc: {
          start: {
            line: 210,
            column: 10
          },
          end: {
            line: 210,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 210,
            column: 10
          },
          end: {
            line: 210,
            column: 25
          }
        }, {
          start: {
            line: 210,
            column: 29
          },
          end: {
            line: 210,
            column: 43
          }
        }],
        line: 210
      },
      "33": {
        loc: {
          start: {
            line: 216,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 216,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        }, {
          start: {
            line: 216,
            column: 6
          },
          end: {
            line: 218,
            column: 7
          }
        }],
        line: 216
      },
      "34": {
        loc: {
          start: {
            line: 223,
            column: 13
          },
          end: {
            line: 223,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 223,
            column: 13
          },
          end: {
            line: 223,
            column: 22
          }
        }, {
          start: {
            line: 223,
            column: 26
          },
          end: {
            line: 223,
            column: 40
          }
        }],
        line: 223
      },
      "35": {
        loc: {
          start: {
            line: 227,
            column: 13
          },
          end: {
            line: 227,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 227,
            column: 13
          },
          end: {
            line: 227,
            column: 27
          }
        }, {
          start: {
            line: 227,
            column: 31
          },
          end: {
            line: 227,
            column: 56
          }
        }],
        line: 227
      },
      "36": {
        loc: {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }, {
          start: {
            line: 231,
            column: 6
          },
          end: {
            line: 231,
            column: 49
          }
        }],
        line: 231
      },
      "37": {
        loc: {
          start: {
            line: 240,
            column: 6
          },
          end: {
            line: 240,
            column: 21
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 240,
            column: 6
          },
          end: {
            line: 240,
            column: 21
          }
        }, {
          start: {
            line: 240,
            column: 6
          },
          end: {
            line: 240,
            column: 21
          }
        }],
        line: 240
      },
      "38": {
        loc: {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 249,
            column: 49
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 249,
            column: 49
          }
        }, {
          start: {
            line: 249,
            column: 6
          },
          end: {
            line: 249,
            column: 49
          }
        }],
        line: 249
      },
      "39": {
        loc: {
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 261,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 261,
            column: 7
          }
        }, {
          start: {
            line: 252,
            column: 6
          },
          end: {
            line: 261,
            column: 7
          }
        }],
        line: 252
      },
      "40": {
        loc: {
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        }, {
          start: {
            line: 255,
            column: 8
          },
          end: {
            line: 258,
            column: 9
          }
        }],
        line: 255
      },
      "41": {
        loc: {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 28
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 28
          }
        }, {
          start: {
            line: 272,
            column: 6
          },
          end: {
            line: 272,
            column: 28
          }
        }],
        line: 272
      },
      "42": {
        loc: {
          start: {
            line: 275,
            column: 6
          },
          end: {
            line: 275,
            column: 37
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 275,
            column: 6
          },
          end: {
            line: 275,
            column: 37
          }
        }, {
          start: {
            line: 275,
            column: 6
          },
          end: {
            line: 275,
            column: 37
          }
        }],
        line: 275
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0, 0],
      "22": [0, 0],
      "23": [0, 0, 0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0],
      "42": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Table/select.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { addEventListener } from '../utils/dom/document';
import { getParent } from '../utils/dom/element';
import { isMacOS, isFirefox } from '../utils/is';
import ready from '../utils/dom/ready';
import { tableClass } from './styles';
var selectClass = (cov_ezqsz1upr.s[0]++, tableClass('select'));
var trClass = (cov_ezqsz1upr.s[1]++, tableClass('normal'));
var noSelection = (cov_ezqsz1upr.s[2]++, tableClass('no-selection')); // event combination

function _isEventCombination(event) {
  cov_ezqsz1upr.f[0]++;
  var ismo = (cov_ezqsz1upr.s[3]++, isMacOS());
  cov_ezqsz1upr.s[4]++;
  return (cov_ezqsz1upr.b[0][0]++, ismo) && (cov_ezqsz1upr.b[0][1]++, event.metaKey) || (cov_ezqsz1upr.b[0][2]++, !ismo) && (cov_ezqsz1upr.b[0][3]++, event.ctrlKey);
} // 根据table tr层次   合并td


function mergeDomsText(nodes) {
  cov_ezqsz1upr.f[1]++;
  cov_ezqsz1upr.s[5]++;

  if ((cov_ezqsz1upr.b[2][0]++, !nodes) || (cov_ezqsz1upr.b[2][1]++, nodes.length <= 0)) {
    cov_ezqsz1upr.b[1][0]++;
    cov_ezqsz1upr.s[6]++;
    return [];
  } else {
    cov_ezqsz1upr.b[1][1]++;
  }

  var trs = (cov_ezqsz1upr.s[7]++, []);
  var res = (cov_ezqsz1upr.s[8]++, []);
  cov_ezqsz1upr.s[9]++;
  nodes.forEach(function (node) {
    cov_ezqsz1upr.f[2]++;
    var tr = (cov_ezqsz1upr.s[10]++, getParent(node, "tr.".concat(trClass)));
    var index = (cov_ezqsz1upr.s[11]++, trs.indexOf(tr));
    cov_ezqsz1upr.s[12]++;

    if (index === -1) {
      cov_ezqsz1upr.b[3][0]++;
      cov_ezqsz1upr.s[13]++;
      trs.push(tr);
      cov_ezqsz1upr.s[14]++;
      index = trs.length - 1;
    } else {
      cov_ezqsz1upr.b[3][1]++;
    }

    cov_ezqsz1upr.s[15]++;

    if (res[index]) {
      cov_ezqsz1upr.b[4][0]++;
      cov_ezqsz1upr.s[16]++;
      res[index].push(node.innerText);
    } else {
      cov_ezqsz1upr.b[4][1]++;
      cov_ezqsz1upr.s[17]++;
      res[index] = [node.innerText];
    }
  });
  cov_ezqsz1upr.s[18]++;
  return res;
} // format table text
// 组合 text


function formatTableText(arrs) {
  cov_ezqsz1upr.f[3]++;
  cov_ezqsz1upr.s[19]++;

  if ((cov_ezqsz1upr.b[6][0]++, !arrs) || (cov_ezqsz1upr.b[6][1]++, arrs.length <= 0)) {
    cov_ezqsz1upr.b[5][0]++;
    cov_ezqsz1upr.s[20]++;
    return '';
  } else {
    cov_ezqsz1upr.b[5][1]++;
  }

  var txt = (cov_ezqsz1upr.s[21]++, '');
  cov_ezqsz1upr.s[22]++;
  arrs.forEach(function (value) {
    cov_ezqsz1upr.f[4]++;
    cov_ezqsz1upr.s[23]++;

    if (typeof value === 'string') {
      cov_ezqsz1upr.b[7][0]++;
      cov_ezqsz1upr.s[24]++;
      txt += "".concat(value, "\t");
    } else {
      cov_ezqsz1upr.b[7][1]++;
      cov_ezqsz1upr.s[25]++;
      txt += "".concat(formatTableText(value), "\n");
    }
  });
  cov_ezqsz1upr.s[26]++;
  return txt;
} // 生成 textarea，并且执行 copy


function execCopyCommand(text) {
  cov_ezqsz1upr.f[5]++;
  cov_ezqsz1upr.s[27]++;

  // if none, return;
  if (!text) {
    cov_ezqsz1upr.b[8][0]++;
    cov_ezqsz1upr.s[28]++;
    return;
  } else {
    cov_ezqsz1upr.b[8][1]++;
  }

  var textarea = (cov_ezqsz1upr.s[29]++, document.createElement('textarea'));
  cov_ezqsz1upr.s[30]++;
  textarea.setAttribute('readonly', 'readonly');
  cov_ezqsz1upr.s[31]++;
  textarea.value = text; // out window

  cov_ezqsz1upr.s[32]++;
  textarea.style.position = 'fixed';
  cov_ezqsz1upr.s[33]++;
  textarea.style.top = '-9999px';
  cov_ezqsz1upr.s[34]++;
  textarea.style.left = '-9999px';
  cov_ezqsz1upr.s[35]++;
  document.body.append(textarea);
  cov_ezqsz1upr.s[36]++;
  textarea.select();
  cov_ezqsz1upr.s[37]++;

  if (document.execCommand('copy')) {
    cov_ezqsz1upr.b[9][0]++;
    cov_ezqsz1upr.s[38]++;
    document.execCommand('copy');
  } else {
    cov_ezqsz1upr.b[9][1]++;
  }

  cov_ezqsz1upr.s[39]++;

  if ((cov_ezqsz1upr.b[11][0]++, textarea) && (cov_ezqsz1upr.b[11][1]++, textarea.parentNode)) {
    cov_ezqsz1upr.b[10][0]++;
    cov_ezqsz1upr.s[40]++;
    textarea.parentNode.removeChild(textarea);
  } else {
    cov_ezqsz1upr.b[10][1]++;
  }
} // remove all selectClass from dom


function removeSelectClass(dom) {
  var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_ezqsz1upr.b[12][0]++, false);
  cov_ezqsz1upr.f[6]++;
  cov_ezqsz1upr.s[41]++;

  if (dom) {
    cov_ezqsz1upr.b[13][0]++;
    cov_ezqsz1upr.s[42]++;
    dom.classList.remove(selectClass);
    cov_ezqsz1upr.s[43]++;
    return;
  } else {
    cov_ezqsz1upr.b[13][1]++;
  }

  cov_ezqsz1upr.s[44]++;

  if (force) {
    cov_ezqsz1upr.b[14][0]++;
    cov_ezqsz1upr.s[45]++;
    return;
  } else {
    cov_ezqsz1upr.b[14][1]++;
  }

  var nodes = (cov_ezqsz1upr.s[46]++, document.querySelectorAll(".".concat(selectClass)));
  cov_ezqsz1upr.s[47]++;

  if (nodes.length <= 0) {
    cov_ezqsz1upr.b[15][0]++;
    cov_ezqsz1upr.s[48]++;
    return;
  } else {
    cov_ezqsz1upr.b[15][1]++;
  }

  cov_ezqsz1upr.s[49]++;
  nodes.forEach(function (elem) {
    cov_ezqsz1upr.f[7]++;
    cov_ezqsz1upr.s[50]++;
    removeSelectClass(elem);
  });
  var node = (cov_ezqsz1upr.s[51]++, document.querySelector(".".concat(noSelection)));
  cov_ezqsz1upr.s[52]++;

  if (node) {
    cov_ezqsz1upr.b[16][0]++;
    cov_ezqsz1upr.s[53]++;
    node.classList.remove(".".concat(noSelection));
  } else {
    cov_ezqsz1upr.b[16][1]++;
  }
} // add selection class


function addSelectionClass(dom) {
  var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_ezqsz1upr.b[17][0]++, selectClass);
  cov_ezqsz1upr.f[8]++;
  cov_ezqsz1upr.s[54]++;

  if (!dom) {
    cov_ezqsz1upr.b[18][0]++;
    cov_ezqsz1upr.s[55]++;
    return;
  } else {
    cov_ezqsz1upr.b[18][1]++;
  }

  cov_ezqsz1upr.s[56]++;
  dom.classList.add(className);
}

function toggleNoSelection(flag) {
  cov_ezqsz1upr.f[9]++;
  cov_ezqsz1upr.s[57]++;

  if (flag) {
    cov_ezqsz1upr.b[19][0]++;
    cov_ezqsz1upr.s[58]++;
    document.body.classList.add(noSelection);
    cov_ezqsz1upr.s[59]++;
    return;
  } else {
    cov_ezqsz1upr.b[19][1]++;
  }

  cov_ezqsz1upr.s[60]++;
  document.body.classList.remove(noSelection);
} // handle document click


function docClick(event) {
  cov_ezqsz1upr.f[10]++;
  var target = (cov_ezqsz1upr.s[61]++, event.target);
  cov_ezqsz1upr.s[62]++;

  if (((cov_ezqsz1upr.b[21][0]++, getParent(target, ".".concat(tableClass('simple-body')))) || (cov_ezqsz1upr.b[21][1]++, getParent(target, ".".concat(tableClass('body'))))) && (cov_ezqsz1upr.b[21][2]++, _isEventCombination(event))) {
    cov_ezqsz1upr.b[20][0]++;
    cov_ezqsz1upr.s[63]++;
    return;
  } else {
    cov_ezqsz1upr.b[20][1]++;
  }

  cov_ezqsz1upr.s[64]++;
  removeSelectClass();
  cov_ezqsz1upr.s[65]++;
  toggleNoSelection();
} // 批量操作
// bulk operation doms


function bulkOperation(doms, start, end) {
  cov_ezqsz1upr.f[11]++;
  cov_ezqsz1upr.s[66]++;

  if ((cov_ezqsz1upr.b[23][0]++, !doms) || (cov_ezqsz1upr.b[23][1]++, doms.childNodes.length <= 0) || (cov_ezqsz1upr.b[23][2]++, start <= -1) || (cov_ezqsz1upr.b[23][3]++, end <= -1)) {
    cov_ezqsz1upr.b[22][0]++;
    cov_ezqsz1upr.s[67]++;
    return;
  } else {
    cov_ezqsz1upr.b[22][1]++;
  }

  var arr = (cov_ezqsz1upr.s[68]++, Array.prototype.slice.call(doms.childNodes, start, end + 1));
  cov_ezqsz1upr.s[69]++;
  arr.forEach(function (dom) {
    cov_ezqsz1upr.f[12]++;
    cov_ezqsz1upr.s[70]++;
    addSelectionClass(dom);
  });
} // 批量操作 -->  添加 selection classname


function bulkAddSelectionClass(td, cache) {
  cov_ezqsz1upr.f[13]++;
  var tr = (cov_ezqsz1upr.s[71]++, getParent(td, "tr.".concat(trClass)));
  cov_ezqsz1upr.s[72]++;

  if (!tr) {
    cov_ezqsz1upr.b[24][0]++;
    cov_ezqsz1upr.s[73]++;
    return;
  } else {
    cov_ezqsz1upr.b[24][1]++;
  }

  var trs = (cov_ezqsz1upr.s[74]++, tr.parentNode.childNodes);
  var xIndex = (cov_ezqsz1upr.s[75]++, Array.prototype.indexOf.call(tr.childNodes, td));
  var count = (cov_ezqsz1upr.s[76]++, 0); // xIndex - cache.xIndex

  cov_ezqsz1upr.s[77]++;

  while (count < trs.length) {
    cov_ezqsz1upr.s[78]++;

    if (cache.yIndex <= count) {
      cov_ezqsz1upr.b[25][0]++;
      var Atr = (cov_ezqsz1upr.s[79]++, trs[count]);
      cov_ezqsz1upr.s[80]++;
      bulkOperation(Atr, cache.xIndex, xIndex);
    } else {
      cov_ezqsz1upr.b[25][1]++;
    }

    cov_ezqsz1upr.s[81]++;

    if (trs[count] === tr) {
      cov_ezqsz1upr.b[26][0]++;
      cov_ezqsz1upr.s[82]++;
      break;
    } else {
      cov_ezqsz1upr.b[26][1]++;
    }

    cov_ezqsz1upr.s[83]++;
    count += 1;
  }
}

function handleKeyDown(event) {
  cov_ezqsz1upr.f[14]++;
  cov_ezqsz1upr.s[84]++;

  if ((cov_ezqsz1upr.b[28][0]++, !_isEventCombination(event)) || (cov_ezqsz1upr.b[28][1]++, event.keyCode !== 67)) {
    cov_ezqsz1upr.b[27][0]++;
    cov_ezqsz1upr.s[85]++;
    return;
  } else {
    cov_ezqsz1upr.b[27][1]++;
  }

  var texts = (cov_ezqsz1upr.s[86]++, formatTableText(mergeDomsText(document.querySelectorAll(".".concat(selectClass)))));
  cov_ezqsz1upr.s[87]++;
  execCopyCommand(texts);
} // ctrl + c


cov_ezqsz1upr.s[88]++;
ready(function () {
  cov_ezqsz1upr.f[15]++;
  cov_ezqsz1upr.s[89]++;
  addEventListener(document, 'keydown', handleKeyDown);
});
export default (function (Table) {
  var _temp;

  cov_ezqsz1upr.f[16]++;
  cov_ezqsz1upr.s[90]++;
  return _temp =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(_temp, _React$Component);

    var _super = _createSuper2(_temp);

    function _temp(props) {
      var _this;

      _classCallCheck(this, _temp);

      cov_ezqsz1upr.f[17]++;
      cov_ezqsz1upr.s[91]++;
      _this = _super.call(this, props);
      _this.doc = void 0;
      _this.isFirefox = void 0;
      _this.events = void 0;
      _this.move = void 0;
      _this.cache = void 0;
      _this.prevDom = void 0;
      cov_ezqsz1upr.s[92]++;
      _this.doc = null;
      cov_ezqsz1upr.s[93]++;
      _this.isFirefox = isFirefox();
      cov_ezqsz1upr.s[94]++;
      _this.events = {};
      cov_ezqsz1upr.s[95]++;
      _this.move = false;
      cov_ezqsz1upr.s[96]++;
      _this.cache = {};
      cov_ezqsz1upr.s[97]++;
      _this.prevDom = null;
      cov_ezqsz1upr.s[98]++;
      _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
      cov_ezqsz1upr.s[99]++;
      _this.handleMouseUp = _this.handleMouseUp.bind(_assertThisInitialized(_this));
      cov_ezqsz1upr.s[100]++;
      _this.handleMouseMove = _this.handleMouseMove.bind(_assertThisInitialized(_this));
      cov_ezqsz1upr.s[101]++;

      if ((cov_ezqsz1upr.b[30][0]++, !_this.isFirefox) && (cov_ezqsz1upr.b[30][1]++, _this.selection)) {
        cov_ezqsz1upr.b[29][0]++;
        cov_ezqsz1upr.s[102]++;
        _this.events.onMouseDown = _this.handleMouseDown;
        cov_ezqsz1upr.s[103]++;
        _this.events.onMouseUp = _this.handleMouseUp;
        cov_ezqsz1upr.s[104]++;
        _this.events.onMouseMove = _this.handleMouseMove;
      } else {
        cov_ezqsz1upr.b[29][1]++;
      }

      return _this;
    }

    _createClass(_temp, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        cov_ezqsz1upr.f[18]++;
        cov_ezqsz1upr.s[105]++;

        if ((cov_ezqsz1upr.b[32][0]++, !this.isFirefox) && (cov_ezqsz1upr.b[32][1]++, this.selection)) {
          cov_ezqsz1upr.b[31][0]++;
          cov_ezqsz1upr.s[106]++;
          this.doc = addEventListener(document, 'click', docClick);
        } else {
          cov_ezqsz1upr.b[31][1]++;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        cov_ezqsz1upr.f[19]++;
        cov_ezqsz1upr.s[107]++;

        if (this.doc) {
          cov_ezqsz1upr.b[33][0]++;
          cov_ezqsz1upr.s[108]++;
          this.doc.remove();
        } else {
          cov_ezqsz1upr.b[33][1]++;
        }
      }
    }, {
      key: "isEventCombination",
      value: function isEventCombination(event) {
        cov_ezqsz1upr.f[21]++;
        cov_ezqsz1upr.s[111]++;
        return (cov_ezqsz1upr.b[35][0]++, this.selection) && (cov_ezqsz1upr.b[35][1]++, _isEventCombination(event));
      }
    }, {
      key: "handleMouseDown",
      value: function handleMouseDown(event) {
        cov_ezqsz1upr.f[22]++;
        cov_ezqsz1upr.s[112]++;

        if (!this.isEventCombination(event)) {
          cov_ezqsz1upr.b[36][0]++;
          cov_ezqsz1upr.s[113]++;
          return;
        } else {
          cov_ezqsz1upr.b[36][1]++;
        }

        cov_ezqsz1upr.s[114]++;
        toggleNoSelection(true); // toggle move

        cov_ezqsz1upr.s[115]++;
        this.move = true;
        var td = (cov_ezqsz1upr.s[116]++, getParent(event.target, 'td'));
        var tr = (cov_ezqsz1upr.s[117]++, getParent(td, "tr.".concat(trClass)));
        cov_ezqsz1upr.s[118]++;
        this.prevDom = td;
        cov_ezqsz1upr.s[119]++;

        if (!tr) {
          cov_ezqsz1upr.b[37][0]++;
          cov_ezqsz1upr.s[120]++;
          return;
        } else {
          cov_ezqsz1upr.b[37][1]++;
        }

        var xIndex = (cov_ezqsz1upr.s[121]++, Array.prototype.indexOf.call(tr.childNodes, td));
        var yIndex = (cov_ezqsz1upr.s[122]++, Array.prototype.indexOf.call(tr.parentNode.childNodes, tr));
        cov_ezqsz1upr.s[123]++;
        this.cache.xIndex = xIndex;
        cov_ezqsz1upr.s[124]++;
        this.cache.yIndex = yIndex;
        cov_ezqsz1upr.s[125]++;
        this.cache.dom = td;
      }
    }, {
      key: "handleMouseUp",
      value: function handleMouseUp(event) {
        cov_ezqsz1upr.f[23]++;
        cov_ezqsz1upr.s[126]++;

        if (!this.isEventCombination(event)) {
          cov_ezqsz1upr.b[38][0]++;
          cov_ezqsz1upr.s[127]++;
          return;
        } else {
          cov_ezqsz1upr.b[38][1]++;
        }

        var target = (cov_ezqsz1upr.s[128]++, event.target);
        var td = (cov_ezqsz1upr.s[129]++, getParent(target, 'td'));
        cov_ezqsz1upr.s[130]++;

        if (td === this.cache.dom) {
          cov_ezqsz1upr.b[39][0]++;
          cov_ezqsz1upr.s[131]++;
          this.cache = {};
          cov_ezqsz1upr.s[132]++;
          this.move = false;
          cov_ezqsz1upr.s[133]++;

          if (td.classList.contains(selectClass)) {
            cov_ezqsz1upr.b[40][0]++;
            cov_ezqsz1upr.s[134]++;
            removeSelectClass(td);
            cov_ezqsz1upr.s[135]++;
            return;
          } else {
            cov_ezqsz1upr.b[40][1]++;
          }

          cov_ezqsz1upr.s[136]++;
          addSelectionClass(td);
          cov_ezqsz1upr.s[137]++;
          return;
        } else {
          cov_ezqsz1upr.b[39][1]++;
        }

        cov_ezqsz1upr.s[138]++;
        this.prevDom = null;
        cov_ezqsz1upr.s[139]++;
        bulkAddSelectionClass(td, this.cache); // reset

        cov_ezqsz1upr.s[140]++;
        this.cache = {};
        cov_ezqsz1upr.s[141]++;
        this.move = false;
      }
    }, {
      key: "handleMouseMove",
      value: function handleMouseMove(event) {
        cov_ezqsz1upr.f[24]++;
        cov_ezqsz1upr.s[142]++;

        if (!this.move) {
          cov_ezqsz1upr.b[41][0]++;
          cov_ezqsz1upr.s[143]++;
          return;
        } else {
          cov_ezqsz1upr.b[41][1]++;
        }

        var td = (cov_ezqsz1upr.s[144]++, getParent(event.target, 'td'));
        cov_ezqsz1upr.s[145]++;

        if (this.prevDom === td) {
          cov_ezqsz1upr.b[42][0]++;
          cov_ezqsz1upr.s[146]++;
          return;
        } else {
          cov_ezqsz1upr.b[42][1]++;
        }

        cov_ezqsz1upr.s[147]++;
        this.prevDom = td; // clear class name

        cov_ezqsz1upr.s[148]++;
        removeSelectClass();
        cov_ezqsz1upr.s[149]++;
        bulkAddSelectionClass(td, this.cache);
      }
    }, {
      key: "render",
      value: function render() {
        cov_ezqsz1upr.f[25]++;

        var _ref = (cov_ezqsz1upr.s[150]++, this.props),
            selection = _ref.selection,
            cellSelectable = _ref.cellSelectable,
            otherProps = _objectWithoutProperties(_ref, ["selection", "cellSelectable"]);

        cov_ezqsz1upr.s[151]++;
        return (
          /*#__PURE__*/
          React.createElement(Table, Object.assign({}, otherProps, {
            events: this.events,
            __self: this,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 286,
              columnNumber: 14
            }
          }))
        );
      }
    }, {
      key: "selection",
      get: function get() {
        cov_ezqsz1upr.f[20]++;

        var _ref2 = (cov_ezqsz1upr.s[109]++, this.props),
            selection = _ref2.selection,
            cellSelectable = _ref2.cellSelectable;

        cov_ezqsz1upr.s[110]++;
        return (cov_ezqsz1upr.b[34][0]++, selection) || (cov_ezqsz1upr.b[34][1]++, cellSelectable);
      }
    }]);

    return _temp;
  }(React.Component), _temp;
});